import axios from "axios";
import { RCS_URL, RCHANS_URL, buildServiceParamMap, findDefaultChannelOfType, mergeById, sortByDate } from "../../common";

import { userInfo } from "../../common/user-info";
import { authHeader } from "../../common/auth-header";
import { relativeTimeThreshold } from "moment";
import jwtInterceptor  from '../../common/jwt-interceptor';

const state = {
  // allMessages: [],
  messageId: null,
  selectedMessage: null,
  commentsByShareId: {},
  allMessagesByRallyId: {}
};

const getters = {
  allMessagesByRallyId: state => {
    //return sortByDate(state.allMessagesByRallyId[id], "attributes", "created-at")
    return state.allMessagesByRallyId;
  },
  messageId: state => state.messageId,
  selectedMessage: state => state.selectedMessage,
  commentsByShareId: state => id => {
    return state.commentsByShareId[id];
  }
};

const actions = {
  async clearMessageState({ commit, state }) {
    commit("clearState");
  },

  async fetchAMessageComments({ commit }, inparams) {
    const { shareId, channelId } = inparams; 
    const user = userInfo();
    var jsonparams = {
      context_channel_id: parseInt(channelId),
      context_id: parseInt(shareId),
      context_type: "Share",
      content_type: "Message",
      include: "creator,creator_avatar,shares",
      sort: "contents.created_at desc" //,
      //page: { size: 4 }
    };
    var params = buildServiceParamMap(jsonparams);
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      },
      url: RCS_URL(),
      params
    };
    const response = await jwtInterceptor(requestOptions);
    if (shareId) {
      commit("setCommentsByShareId", {
        id: shareId,
        comments: response.data.data
      });
    }
    if (response.data.data && response.data.data.forEach) {
      response.data.data.forEach(c => {
        let cuser = {attributes:{}}
        cuser.attributes["first-name"] = c.attributes["creator-first-name"]
        cuser.attributes["last-name"] = c.attributes["creator-last-name"]
        cuser.attributes["avatar"] =  c.attributes["creator-avatar"]
        cuser.attributes["avatar"] =  c.attributes["creator-avatar"]
        cuser.id = c.attributes["creator-id"] + ""
        this.dispatch("user/setUsersById", { users: [cuser]});
      })
    }
  },

  //Parameters: {content"=>{"content_type"=>"Message", "context_id"=>"10134587", "context_type"=>"Share", "type"=>"Comment", "body"=>"another comment here..."}, "rally_id"=>"39017", "channel_id"=>"messages"}
  async createComment({ commit, state }, inparams) {
    const user = userInfo();
    const { rallyId, channelId } = inparams;
    console.log("createcomments....")
    const requestOptions = {
      method: "POST",
      //url: "http://192.168.1.19:3020/api/v1/contents",
      url: RCS_URL(),
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        data: {
          type: "contents",
          attributes: {
            content_type: "Message",
            context_id: inparams.shareId,
            context_channel_id: channelId,
            context_rally_id: rallyId,
            context_type: "Share",
            type: "Comment",
            body: inparams.body,
            creator_id: user.user_id
          },
          rally_id: rallyId,
          channel_id: "messages"
        }
      }
    };
    const response = await jwtInterceptor(requestOptions);
    //this.dispatch("messages/fetchAMessage", {});
    this.dispatch("messages/fetchAMessageComments", {shareId: inparams.shareId, channelId });
  },

  async createMessage({ commit, state }, inparams) {
    console.log("createmessage.....")
    const { priority, newMessage, channelId, status, rallyId, tempKey } = inparams;
    const user = userInfo();
    const createdAttributes = {
      priority,
      context_id: rallyId,
      status,
      context: "Rally",
      context_type: "Rally",
      title: newMessage.title,
      body: newMessage.body,
      context_channel_id: channelId,
      context_rally_id: rallyId,
      content_type: "Message",
      type: "WallMessage",
      include: "creator,creator_avatar",
      creator_id: user.user_id
    };
    const requestOptions = {
      method: "POST",
      url: RCS_URL(),
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        data: {
          type: "contents",
          attributes: createdAttributes
        }
      }
    };

    //commit("setAllMessages", [{id:123, message: {attributes: createdAttributes}}]);
    const response = await jwtInterceptor(requestOptions);
    //we don't have the real info from the backend yet but when we are creating it then its editable and deletable by us...
    response.data.data.attributes["editable"] = true
    response.data.data.attributes["deletable"] = true
    response.data.data.attributes["creator-first-name"] = user.first_name
    response.data.data.attributes["creator-last-name"] = user.last_name
    this.dispatch("contents/setContentById", { id: response.data.data.id, content: response.data.data, tempKey });
  },

  async createDirectMessage({ commit, state }, inparams) {
    const { newMessage, channelId, status, rallyId, tempKey } = inparams;
    const user = userInfo();
    const createdAttributes = {
      context_id: channelId,
      context_type: "Channel",
      title: newMessage.title,
      body: newMessage.body,
      context_channel_id: channelId,
      context_rally_id: rallyId,
      content_type: "Message",
      type: "PrivateMessage",
      include: "creator,creator_avatar",
      creator_id: user.user_id
    };
    const requestOptions = {
      method: "POST",
      url: RCS_URL(),
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        data: {
          type: "contents",
          attributes: createdAttributes
        }
      }
    };

    //commit("setAllMessages", [{id:123, message: {attributes: createdAttributes}}]);
    const response = await jwtInterceptor(requestOptions);
    this.dispatch("contents/setContentById", { id: response.data.data.id, content: response.data.data, tempKey });
  },

  //Started PUT "/38455/messages/19024003" for 127.0.0.1 at 2020-12-14 01:14:18 -0600
  //Processing by ContentsController#update as HTML
  //Parameters: {"utf8"=>"✓", "authenticity_token"=>"xlVu6BQ6fa87LNXvarQdt7wJqgJqLKKkc+FZ3bDm3KpOeXApkjycVmEvjE7hxuY4etMl3J3pJPvwCduZ08qDNQ==", "content"=>{"title"=>"dec13-8-8 rally-msg1(edit)", "body"=>"dec13-8-8 rally-msg1....(edit)"}, "rally_id"=>"38455", "channel_id"=>"messages", "id"=>"19024003"}

  //Started PUT "/api/v1/contents/19024003.json" for 127.0.0.1 at 2020-12-14 18:37:33 -0600
  //Processing by Api::V1::ContentsController#update as JSON
  //Parameters: {"data"=>{"type"=>"contents", "attributes"=>{"id"=>"19024003", "content_id"=>2326377, "content_type"=>"Message", "creator_first_name"=>"Jason", "creator_last_name"=>"Topliff", "creator_avatar"=>"https://files-dev.rallyhood.com/public/system/media/805102/small/Screen%20Shot%202020-12-08%20at%203.27.35%20PM.png?1607551620&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9maWxlcy1kZXYucmFsbHlob29kLmNvbS9wdWJsaWMvc3lzdGVtL21lZGlhLzgwNTEwMi9zbWFsbC9TY3JlZW4lMjBTaG90JTIwMjAyMC0xMi0wOCUyMGF0JTIwMy4yNy4zNSUyMFBNLnBuZz8xNjA3NTUxNjIwIiwiQ29uZGl0aW9uIjp7IkRhdGVMZXNzVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNjM5NTI4NjUzfX19XX0_&Signature=CNmjYYu4S9zuuPl1ug867XdhuG29KJOvcd8sorX2pQXJmCpqE29iD4QJ9Mq86IKlpJArC3TWROl26KcyVQAZpn-fTP~KFXMCOFAeDWCRH~a8w1Ms5Ekjl~4OTjqJicQ3chJcI78VmICgS28EP9aqeohxfwrSY9uAeo7bzWTe1DwmRpv7jSAcve-Sm6j09SAPetVuRoGoQ3TfxTPiFuYPFdX5q7PgWHAUs-VtXGUD3qagleyWRw5F1WaBVfAAE2dlK8rzfA1wdGIzL2Y2vPzeNGosRmIes~61y2WmFPYhXszayX64VIHUxliW7HNfL8r8lrlceGU6bdhfk03OJdT8aA__&Key-Pair-Id=APKAJMMEX4NASVK5VJHQ", "title"=>"dec13-8-8 rally-msg1(edit)1234", "type"=>"WallMessage", "description"=>"dec13-8-8 rally-msg1....(edit)", "creator_id"=>303137, "status"=>1, "max_participants"=>0, "participant_count"=>nil, "participant_total"=>nil, "privacy"=>nil, "highlight_title"=>"", "legacy_id"=>nil, "legacy_type"=>nil, "security"=>0, "subcontents_count"=>nil, "created_at"=>"2020-12-14T05:04:56.000Z", "updated_at"=>"2020-12-14T07:14:23.000Z", "editable"=>true, "deletable"=>true, "links"=>{"self"=>"http://localhost:3020/api/v1/contents/19024003"}, "body"=>"dec13-8-8 rally-msg1....(edit) 123", "highlight_body"=>"", "included_objects"=>[], "avatar"=>{"id"=>"-1", "background"=>"", "large_url"=>"//rallyhood-assets.s3.amazonaws.com/default/rally_avatars/3/large/rally_avatar.jpg", "medium_url"=>"//rallyhood-assets.s3.amazonaws.com/default/rally_avatars/3/large/rally_avatar.jpg", "small_url"=>"//rallyhood-assets.s3.amazonaws.com/default/rally_avatars/3/large/rally_avatar.jpg", "url"=>"//rallyhood-assets.s3.amazonaws.com/default/rally_avatars/3/large/rally_avatar.jpg", "links"=>{"self"=>"http://localhost:3020/api/v1/-1"}}, "owner_share"=>{"id"=>"10134608", "content_uid"=>19024003, "context_type"=>"Channel", "context_id"=>178867, "context_rally_id"=>38455, "creator_id"=>303137, "publication_rule_id"=>nil, "owner"=>true, "flagged"=>nil, "priority"=>nil, "share_type"=>"original", "status"=>1, "sort_order"=>nil, "visibility"=>"all", "context_channel_id"=>178867, "legacy_id"=>nil, "legacy_type"=>nil, "total_comments"=>nil, "created_at"=>"2020-12-14T05:04:56.000Z", "updated_at"=>"2020-12-14T23:23:30.000Z", "links"=>{"self"=>"http://localhost:3020/api/v1/shares/10134608"}}, "context_share"=>{"id"=>"10134608", "content_uid"=>19024003, "context_type"=>"Channel", "context_id"=>178867, "context_rally_id"=>38455, "creator_id"=>303137, "publication_rule_id"=>nil, "owner"=>true, "flagged"=>nil, "priority"=>nil, "share_type"=>"original", "status"=>1, "sort_order"=>nil, "visibility"=>"all", "context_channel_id"=>178867, "legacy_id"=>nil, "legacy_type"=>nil, "total_comments"=>nil, "created_at"=>"2020-12-14T05:04:56.000Z", "updated_at"=>"2020-12-14T23:23:30.000Z", "links"=>{"self"=>"http://localhost:3020/api/v1/shares/10134608"}}, "shares"=>[{"id"=>"10134608", "content_uid"=>19024003, "context_type"=>"Channel", "context_id"=>178867, "context_rally_id"=>38455, "creator_id"=>303137, "publication_rule_id"=>nil, "owner"=>true, "flagged"=>nil, "priority"=>nil, "share_type"=>"original", "status"=>1, "sort_order"=>nil, "visibility"=>"all", "context_channel_id"=>178867, "legacy_id"=>nil, "legacy_type"=>nil, "total_comments"=>nil, "created_at"=>"2020-12-14T05:04:56.000Z", "updated_at"=>"2020-12-14T23:23:30.000Z", "links"=>{"self"=>"http://localhost:3020/api/v1/shares/10134608"}}], "include"=>"creator,creator_avatar"}}, "id"=>"19024003"}
  async saveMessage({ commit, state, getters, rootGetters }, inparams) {
    const { message, rallyId, channelId, status, priority} = inparams;
    var usersById = rootGetters['user/usersById']
    const user = userInfo();
    const mid = message.id;
    const requestOptions = {
      method: "PUT",
      url: RCS_URL() + `/${mid}`,
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        data: {
          type: "contents",
          id: mid,
          attributes: {
            id: mid,
            rally_id: rallyId,
            content_type: "Message",
            content_id: message.attributes["content_id"],
            title: message.attributes.title,
            body: message.attributes.body,
            type: "WallMessage",
            status,
            priority
          }
        }
      }
    };
    try {
      var response = await jwtInterceptor(requestOptions);
      var fetchParams = {
        rallyId: this.rallyId,
        contextType: "Channel",
        contextChannelId: channelId,
        contextId: channelId,
        pageNumber: 1,
        contentType: "Message",
        type: "WallMessage"
      };
      response.data.data.attributes.title = message.attributes.title
      response.data.data.attributes.body = message.attributes.body 
      response.data.data.attributes.editable == true
      response.data.data.attributes.deletable == true
      message.attributes.editable = true
      message.attributes.deletable= true
      let u = usersById[response.data.data.attributes['creator-id']]
      if (u){
        response.data.data.attributes["creator-first-name"] = u.attributes['first-name']
        response.data.data.attributes["creator-last-name"] = u.attributes['last-name']
      }
      this.dispatch("contents/setAllContentByContextTypeAndId", {prefix: true, contextType:"", contextId:channelId, contents: [response.data.data]});
      //this.dispatch("contents/fetchContents", fetchParams);
      this.dispatch("contents/setContentById", { id: response.data.data.id, content: message});
      // this.dispatch("contents/setAllContentByContextTypeAndId", { contextType:"", contextId: channelId, contents: message});
    } catch (e) {
      this._vm.$log.error(e);
    }
  },

  async addCommentToStore({ commit, state }, params) {
    commit("addACommentByShareId", params.comment);
  }
};

const mutations = {
  //clearAllMessages: state => (state.allMessages = []),
  clearState: state => {
    state.messageId = null;
    state.selectedMessage = null;
    state.commentsByShareId = {};
    state.allMessagesByRallyId = {};
  },
  setMessagesByRallyId: (state, params) => {
    const { rallyId, messages } = params;
    var curarr = state.allMessagesByRallyId[rallyId];
    if (!curarr) {
      curarr = [];
    }
    var theMessages = messages ? messages : [];
    var newarr = mergeById(curarr, theMessages, "id");
    var byIdObj = {};
    byIdObj[rallyId] = sortByDate(newarr, "attributes", "created-at");
    state.allMessagesByRallyId = { ...state.allMessagesByRallyId, ...byIdObj };
  },
  //setAllMessages: (state, messages) => (state.allMessages = mergeById([...state.allMessages], [...messages], "id")),
  setMessageId: (state, id) => (state.messageId = id),
  setSelectedMessage: (state, sel_message) => (state.selectedMessage = sel_message),
  addACommentByShareId: (state, c) => {
    var currarr = state.commentsByShareId[c.shareId];
    if (!currarr) {
      currarr = [];
    }
    var carr = [...currarr, c];
    var cobj = {};
    cobj[c.shareId] = sortByDate(carr, "attributes", "created-at");
    state.commentsByShareId = { ...state.commentsByShareId, ...cobj };
  },
  setCommentsByShareId: (state, c) => {
    var cc = {};
    cc[c.id] = sortByDate(c.comments, "attributes", "created-at");
    state.commentsByShareId = { ...state.commentsByShareId, ...cc };
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
